import { InvoicingTypes } from './invoicingTypes';

export const invoicingReducer = {
  resetError: (state: InvoicingTypes) => {
    state.error = null;
    state.message = null;
  },
  resetSuccess: (state: InvoicingTypes) => {
    state.success = null;
    state.message = null;
  },
  resetStatusCode: (state: InvoicingTypes) => {
    state.statusCode = null;
  },
  resetInvoicingFetching: (state: InvoicingTypes) => {
    state.fetching = false;
  },
  resetBulkUploadData: (state: any) => {
    state.bulkUploadData = {};
  }
}